import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {GroupParticipantCreate} from "./group-participant-create";
import {TeacherAutocompleteAdapter} from "../../person-autocomplete/person-autocomplete-adapters";
import {ActivatedRoute} from "@angular/router";
import {Adapter} from "../../person-autocomplete/person-autocomplete.component";
import {Observable} from "rxjs";
import {V3GroupTeacher, V3Teacher} from "../../../model/v3/schools";
import {GroupV3RestService} from "../../../services/rest/v3/group-rest.service";
import {TeacherV3RestService} from "../../../services/rest/v3/teacher-rest.service";
import {ManagerUtils} from "../../../services/utils/v3/manager-utils";
import {V3Person, V3PersonDetails} from "../../../model/v3/people";
import {formatDate} from "@angular/common";

@Component({
    selector: 'app-group-teacher-create',
    templateUrl: './group-participant-create.component.html',
    styleUrls: ['./group-participant-create.component.scss'],
    standalone: false
})
export class GroupTeacherCreateComponent extends GroupParticipantCreate<V3Teacher> implements OnInit {

  participant = {} as V3GroupTeacher
  participantAdapter: Adapter<V3Teacher>;

  constructor(activatedRoute: ActivatedRoute,
              groupV3Rest: GroupV3RestService,
              teacherV3Rest: TeacherV3RestService,
              @Inject(LOCALE_ID) private locale: string
  ) {
    super(activatedRoute, groupV3Rest, null, teacherV3Rest)
  }

  ngOnInit(): void {
  }

  setupAutocompleteAdapters() {
    this.participantAdapter = new TeacherAutocompleteAdapter(this.schoolId, this.teacherV3Rest);
  }

  participantSelected(teacher: V3GroupTeacher, selectedTeacher: V3Teacher) {
    this.isParticipantSelected = true
    this.participant = JSON.parse(JSON.stringify(teacher)) as V3GroupTeacher
    this.participant.member = JSON.parse(JSON.stringify(selectedTeacher)) as V3Teacher
    this.participant.member.person.details.name = ManagerUtils.getName(selectedTeacher.person);
    if (this.participant.from)
      this.participant.from = formatDate(this.participant.from, "yyyy-MM-dd", this.locale) as unknown as number;
    if (this.participant.to)
      this.participant.to = formatDate(this.participant.to, "yyyy-MM-dd", this.locale) as unknown as number;
  }

  addParticipant() {
    this.isParticipantBeingAdded = true
    this.resetParticipantObject()
  }
  resetParticipantObject() {
    this.unlinkParticipant()
    this.groupParticipantForm.resetForm()
    this.isParticipantSelected = false
    this.participant = {} as V3GroupTeacher;
    this.participant.member = {} as V3Teacher
    this.participant.member.person = {} as V3Person
    this.participant.member.person.details = {} as V3PersonDetails
    this.participant.member.person.details.name = ""
  }

  saveParticipant() {
    this.participant.labels = this.labels?.split(',')
    let observable: Observable<any>
    if(!this.isParticipantBeingEdited)
      observable = this.groupV3Rest.addGroupTeacher(this.schoolId, this.groupId, this.participant)
    else
      observable = this.groupV3Rest.updateMemberDetails(this.schoolId, this.groupId, this.participant.id, this.participant)

    observable.subscribe(_ => {
      this.isParticipantBeingAdded = false
      this.isParticipantBeingEdited = false
      this.reloadGroupEmitter.emit()
    })
    this.resetParticipantObject()
  }
}
